import React, { Ref, useEffect, useImperativeHandle, useState } from "react";
import {
  Avatar,
  Col,
  Form,
  Image,
  Row,
  Select,
  Tooltip,
  Typography,
} from "antd";
import {
  birthday2Age,
  convertIosStringToDateMoment,
  convertIosStringToDateObjectDayjs,
  formatDateToString,
  convertDateStringToDateTimezone_7,
  convertDateStringToDateTimezone_7Dayjs,
} from "helper/common";
import moment from "moment";

import { UserOutlined } from "@ant-design/icons";
import { getImageSrc } from "pages/Receive/ExtendCard/config";
import "./PatientInfo.scss";
import { InputFields, Notification } from "components/common";
import { useAppSelector } from "redux/hooks";
import { fields } from "./config";
import { FORMAT_TIME, tabKeys } from "types/enums";
import dayjs from "dayjs";

export type PatientInfoRef = {
  getFormValue: () => any;
};
const professions = [
  { label: "Lễ tân", value: 1 },
  { label: "Bác sỹ", value: 2 },
  { label: "Điều dưỡng", value: 3 },
  { label: "Tư vấn", value: 4 },
  { label: "Kính", value: 5 },
  { label: "Xét nghiệm", value: 6 },
  { label: "Thuốc", value: 7 },
  { label: "Chăm sóc khách hàng", value: 8 },
  { label: "Nội trú", value: 9 },
];
type Props = {
  dataCustomerCare: any;
  childTab?: any;
  ref?: Ref<PatientInfoRef>;
};
const PatientInfo = React.forwardRef<PatientInfoRef, Props>((props, ref) => {
  const id = useAppSelector((e) => e.customerCare.idCustomerCare);
  const [dataField, setDataField] = useState(fields());
  const { dataCustomerCare, childTab } = props;
  const [disabled, setDisabled] = useState(true);

  const [form] = Form.useForm();

  //set lai value
  useEffect(() => {
    if (dataCustomerCare) {
      console.log("🚀 ~ useEffect ~ dataCustomerCare:", dataCustomerCare);
      form.setFieldsValue({
        ...dataCustomerCare,
        ngayHenPT: convertIosStringToDateObjectDayjs(
          dataCustomerCare?.ngayHenPT
        ),
        ngayHenTaiKham: convertIosStringToDateObjectDayjs(
          dataCustomerCare?.ngayHenTaiKham
        ),
        ngayKCB: convertIosStringToDateMoment(dataCustomerCare?.ngayKCB),
        tuoi: birthday2Age(dataCustomerCare?.ngaySinh),
        nhanVienCSKH:
          dataCustomerCare?.nhanVienCSKH ?? localStorage.getItem("fullName"),
        // loaiKcb: loaiKCB.map
        boPhanCaiTien: [],
        cacVanDe: [],
      });

      setDisabled(false);
    } else {
      form.resetFields();
      form.setFieldValue("boPhanCaiTien", []);
      form.setFieldValue("cacVanDe", []);
      setDisabled(false);
    }
  }, [dataCustomerCare]);
  useEffect(() => {
    //   document.addEventListener('DOMContentLoaded', function () {
    //     var selectElement = document.getElementById('yourMultiSelectId');
    //     var firstOption = selectElement.querySelector('option:first-child');
    //     selectElement.removeChild(firstOption);
    // });
    // form.setFieldValue("boPhanCaiTien", []);
  }, []);
  //dev
  // useEffect(() => {
  //   form.resetFields();
  //   if (childTab === tabKeys.CUSTOMER_CARE.REJECT) {
  //     dataField.find((e) => e.name === "ngayHenPT").label = "TG hẹn gọi lại";
  //     dataField.find((e) => e.name === "ngayHenPT").rules = [
  //       { required: true, message: "Chưa nhập thời gian hẹn gọi lại" },
  //     ];
  //     dataField.find((e) => e.name === "trangThaiCSKH").hide = false;
  //     setDataField([...dataField]);
  //   } else if (childTab === tabKeys.CUSTOMER_CARE.REMAIN_PATIENT) {
  //     console.log(childTab);

  //     dataField.find((e) => e.name === "ngayHenPT").label = "Ngày hẹn TK";
  //     form.setFieldValue("ngayHenPT", null);

  //     dataField.find((e) => e.name === "ngayHenPT").rules = null;
  //     dataField.find((e) => e.name === "trangThaiCSKH").hide = false;
  //     setDataField([...dataField]);
  //   } else {
  //     dataField.find((e) => e.name === "trangThaiCSKH").hide = false;
  //     dataField.find((e) => e.name === "ngayHenPT").label = "Ngày hẹn TK";
  //   }
  //   form.setFieldValue("boPhanCaiTien", []);
  //   form.setFieldValue("cacVanDe", []);
  //   setDisabled(true);
  // }, [childTab]);

  //Live
  useEffect(() => {
    form.resetFields();
    console.log(dataField);

    if (childTab === tabKeys.CUSTOMER_CARE.REJECT) {
      dataField.find((e) => e.name === "ngayHenPT" || "ngayHenTaiKham").name =
        "ngayHenPT";
      dataField.find((e) => e.name === "ngayHenPT").label = "TG hẹn gọi lại";
      dataField.find((e) => e.name === "ngayHenPT").rules = [
        { required: true, message: "Chưa nhập thời gian hẹn gọi lại" },
      ];
      dataField.find((e) => e.name === "trangThaiCSKH").hide = false;
      setDataField([...dataField]);
    }
    if (
      childTab === tabKeys.CUSTOMER_CARE.REMAIN_PATIENT ||
      childTab === tabKeys.CUSTOMER_CARE.BACK_TO_THE_DOCTOR
    ) {
      console.log(childTab);

      dataField.find((e) => e.name === "ngayHenPT" || "ngayHenTaiKham").label =
        "Ngày hẹn TK";
      form.setFieldValue("ngayHenPT", null);

      dataField.find((e) => e.name === "ngayHenPT" || "ngayHenTaiKham").rules =
        null;
      dataField.find((e) => e.name === "ngayHenPT" || "ngayHenTaiKham").name =
        "ngayHenTaiKham";

      dataField.find((e) => e.name === "trangThaiCSKH").hide = false;
      setDataField([...dataField]);
    } else {
      dataField.find((e) => e.name === "ngayHenPT" || "ngayHenTaiKham").name =
        "ngayHenPT";
      dataField.find((e) => e.name === "trangThaiCSKH").hide = false;
      dataField.find((e) => e.name === "ngayHenPT" || "ngayHenTaiKham").name =
        "ngayHenPT";

      dataField.find((e) => e.name === "ngayHenPT" || "ngayHenTaiKham").label =
        "Ngày hẹn TK";
    }
    form.setFieldValue("boPhanCaiTien", []);
    form.setFieldValue("cacVanDe", []);
    setDisabled(true);
  }, [childTab]);
  useEffect(() => {
    if (id == null) {
      dataField.map((e) => (e.disable = true));

      setDataField([...dataField]);
    } else {
      dataField.map((e) => (e.disable = false));
      setDataField([...dataField]);
    }
  }, [id]);

  const formatFormValue = async () => {
    const rawValues = await form.validateFields();
    const formatValues = {
      ...rawValues,
      ngaySinh: formatDateToString(rawValues.ngaySinh, null),
    };
    return formatValues;
  };

  useImperativeHandle(ref, () => ({
    getFormValue: () => {
      return formatFormValue();
    },
    setDisabled: setDisabled,
  }));
  const gender = () => {
    if (dataCustomerCare) {
      if (dataCustomerCare.gioiTinh === 0) {
        return "Nam";
      }
      if (dataCustomerCare.gioiTinh === 1) {
        return "Nữ";
      }
    } else return "?? ";
  };

  return (
    <div className="patient-info">
      <Row gutter={[16, 8]} style={{ paddingBottom: "10px" }}>
        <Col flex={"auto"}>
          {dataCustomerCare?.anh ? (
            <Image
              // width={140}
              sizes="auto"
              height={"auto"}
              src={getImageSrc(dataCustomerCare.anh)}
              preview={false}
            />
          ) : (
            <Avatar icon={<UserOutlined />} shape="square" size={140} />
          )}
        </Col>
        {id ? (
          <Col span={19}>
            <Row gutter={[16, 8]}>
              <Typography.Text style={{ fontWeight: "bold" }}>
                {dataCustomerCare?.hoTen ?? "?? "} -
              </Typography.Text>
              <Typography.Text style={{ fontWeight: "bold" }}>
                &nbsp;
                {gender()} -
              </Typography.Text>

              <Typography.Text style={{ fontWeight: "bold" }}>
                &nbsp;
                {birthday2Age(dataCustomerCare?.ngaySinh)}
                {birthday2Age(dataCustomerCare?.ngaySinh)
                  .toString()
                  .includes("tháng")
                  ? "?? "
                  : "tuổi"}
                (SN:&nbsp;
                {dataCustomerCare
                  ? convertDateStringToDateTimezone_7Dayjs(
                      dataCustomerCare?.ngaySinh,
                      FORMAT_TIME.dayFull
                    )
                  : "?? "}
                ) -
              </Typography.Text>

              <Typography.Text className="form" style={{ fontWeight: "bold" }}>
                &nbsp;
                <Tooltip title={"Mã bệnh nhân"}>
                  {dataCustomerCare?.maBenhNhan ?? "?? "} -
                </Tooltip>
              </Typography.Text>
              <Typography.Text style={{ fontWeight: "bold" }}>
                &nbsp;
                <Tooltip title={"Mã phiếu khám"}>
                  {dataCustomerCare?.idPhieuKham ?? "?? "}
                </Tooltip>
              </Typography.Text>
            </Row>
            <Row>
              <Col span={12}>
                <Row>
                  Ngày khám bệnh:
                  <Typography.Text ellipsis={true} className="header-title">
                    {convertIosStringToDateMoment(dataCustomerCare?.ngayKCB)}
                  </Typography.Text>
                </Row>
              </Col>
              <Col span={12}>
                <Row>
                  Bác sĩ:
                  <Typography.Text ellipsis={true} className="header-title">
                    {dataCustomerCare?.bacSiChiDinh ?? " -- "}
                  </Typography.Text>
                </Row>
              </Col>

              <Col span={12}>
                <Row>
                  Loại KCB:
                  <Typography.Text ellipsis={true} className="header-title">
                    {JSON.parse(localStorage.getItem("loaiKCB"))?.find(
                      (e) => e.value === dataCustomerCare?.loaiKcb
                    )?.label ?? "--"}
                  </Typography.Text>
                </Row>
              </Col>

              <Col span={12}>
                <Row>
                  Số BHYT:
                  <Typography.Text ellipsis={true} className="header-title">
                    {dataCustomerCare?.maTheBhyt ?? " -- "}
                  </Typography.Text>
                </Row>
              </Col>
              <Col span={12}>
                <Row>
                  Trạng thái PK:
                  <Typography.Text ellipsis={true} className="header-title">
                    {JSON.parse(localStorage.getItem("TTPhieu"))?.find(
                      (e) => e.value === dataCustomerCare?.trangThaiPhieuKham
                    )?.label ?? " -- "}
                  </Typography.Text>
                </Row>
              </Col>

              <Col span={12}>
                <Row>
                  Trạng thái BHYT:
                  <Typography.Text ellipsis={true} className="header-title">
                    {JSON.parse(localStorage.getItem("TTBH"))?.find(
                      (e) => e.value === dataCustomerCare?.trangThaiBHYT
                    )?.label ?? " -- "}
                  </Typography.Text>
                </Row>
              </Col>
              <Col span={24}>
                <Row>
                  Địa chỉ:
                  <Typography.Text ellipsis={true} className="header-title">
                    {dataCustomerCare?.diaChi ?? " -- "}
                  </Typography.Text>
                </Row>
              </Col>
            </Row>
          </Col>
        ) : (
          <Col
            span={19}
            style={{
              fontSize: "20px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            Không có thông tin bệnh nhân
          </Col>
        )}
      </Row>
      <Form labelAlign="left" form={form}>
        <Row gutter={[16, 8]}>
          <InputFields data={dataField} />
        </Row>
        {/* <Form.Item name="boPhanCaiTien" label="My Select" >
        <Select mode="tags">
          <Option value="option1">Option 1</Option>
          <Option value="option2">Option 2</Option>
          <Option value="option3">Option 3</Option>
        </Select>
      </Form.Item> */}
      </Form>
    </div>
  );
});
export default PatientInfo;
